var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { ref, reactive } from "vue-demi";
function useHandling(handler) {
  const handling = ref(false);
  const execute = async (...args) => {
    handling.value = true;
    try {
      return await handler(...args);
    } finally {
      handling.value = false;
    }
  };
  return [handling, execute];
}
function useModal(arg1, arg2) {
  const defaultProps = typeof arg1 === "object" ? arg1 : {};
  const okHandler = typeof arg1 === "function" ? arg1 : arg2;
  const props = reactive(__spreadValues({ visible: false }, defaultProps));
  const show = (newProps) => {
    props.visible = true;
    if (newProps)
      Object.assign(props, newProps);
  };
  const hide = () => {
    props.visible = false;
  };
  const ok = async (...args) => {
    try {
      if (typeof okHandler === "function")
        await okHandler(...args);
      hide();
    } catch (error) {
      console.warn("[useModal]:", error);
    }
  };
  const cancel = () => {
    hide();
  };
  const listeners = { ok, cancel };
  return { props, show, hide, ok, cancel, listeners };
}
function useToggle(defaultValue = false) {
  const bool = ref(defaultValue);
  const toggle = () => {
    bool.value = !bool.value;
  };
  return [bool, toggle];
}
export { useHandling, useModal, useToggle };
